// const formOptionSelectorLength = document.querySelectorAll('.product-form__option-selector').length;

// if (formOptionSelectorLength > 1) {
//   document.querySelectorAll('.product-form__option-selector input[type="radio"]').forEach( inputElement => {
//     inputElement.addEventListener( 'change', () => {
//       if (inputElement.name !== `option${formOptionSelectorLength}`) {

//         const optionSelectorArray = [...document.querySelectorAll('.product-form__option-selector input[type="radio"]:checked')];

//         const optionSelectedArray = optionSelectorArray.map( optionSelectedItem => {
//           if (optionSelectedItem.name !== `option${formOptionSelectorLength}`) {
//             return optionSelectedItem.value;
//           }
//         });

//         document.querySelectorAll(`.product-form__option-selector input[name="option${formOptionSelectorLength}"]`).forEach( inputLastElement => {
//           optionSelectedArray[optionSelectedArray.length - 1] = inputLastElement.value;
//           const variantTitle = optionSelectedArray.join(' / ');
          
//           const inputLabel = inputLastElement.parentElement.querySelector('label');
//           const discountLabelSelector = inputLastElement.parentElement.querySelector('.block-swatch__discount-label');
//           const discountSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="23" viewBox="0 0 46 23" fill="none"><path d="M1.82178 0L46 3.91L40.3069 13.11L44.1782 23L0 18.86L5.69307 9.66L1.82178 0Z" fill="#35907E"></path></svg>';
          
//           if (discountLabelSelector) discountLabelSelector.remove();
          
//           variants.forEach( variant => {
//             if (variant.available && variant.title == variantTitle && variant.compare_at_price > variant.price) {
//               console.log(variant.available);
//               const discount = Math.round((((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
//               const discountHTML = `<span class="block-swatch__discount-label">${discountSVG}<span style="color: #F6ECEC">${discount}%</span></span>`;
              
//               inputLabel.innerHTML = inputLabel.innerHTML + discountHTML;
//             }
//           });
//         });
//       }
//     });
//   });
// }
if (window.giftLevels) {
	document.addEventListener('cart:updated', async function (event) {
		var cart = event.detail.cart;
		const updates = {};
		window.giftLevels.forEach((giftLevel) => {
			const isGiftLevelActive = cart.total_price >= giftLevel.threshold;
			if (!isGiftLevelActive) {
				const giftItemsInCart = cart.items.filter((item) => {
					return giftLevel.giftIds.includes(item.product_id);
				});
				giftItemsInCart.forEach((item) => {
					updates[item.variant_id] = 0;
				});
			}
		});

		if (Object.keys(updates).length > 0) {
			const data = {
				updates: updates,
				sections: ['mini-cart'],
			};
			const response = await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
				body: JSON.stringify(data),
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
			});
			const responseJson = await response.json();
			if (response.ok) {
				if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
					return (window.location.href = `${Shopify.routes.root}cart`);
				}
				document.documentElement.dispatchEvent(
					new CustomEvent('cart:refresh', {
						bubbles: true,
						detail: {
							cart: responseJson,
							replacementDelay: 400,
						},
					}),
				);
			}
		}
	});
}


document.addEventListener('DOMContentLoaded', async () => {
	window.goToCheckout = async (event) => {
		event.preventDefault();
		// const preventCheckout = await checkGiftRules();
		// if(preventCheckout) return;
		const allGiftsSelected = Array.from(
			document.querySelectorAll('.drawer__content--gift > .gift-level__wrapper'),
		).every((item) => item.hasAttribute('gift-already-in-cart'));
		const checkoutBar = document.querySelector('checkout-bar');
		if (checkoutBar && !allGiftsSelected) {
			checkoutBar.open = true;
		} else {
			window.location.href = '/checkout';
		}
	};
	// reviews.io
	const productFacet = document.querySelector('product-facet');
	productFacet?.addEventListener('pagination:page-changed', (event) => {
		setTimeout(() => {
			ratingSnippet('ruk_rating_snippet', {
				store: 'denkriesen',
				mode: 'default',
				color: '#10ACDE',
				linebreak: false,
				lang: 'de',
				usePolaris: true,
				showEmptyStars: false,
			});
		}, 1000);
	});
	const productStar = document.querySelector('[scroll-to-review]');
	setTimeout(() => {
		const clonedStar = productStar?.cloneNode(true);
		productStar?.parentNode.replaceChild(clonedStar, productStar);

		clonedStar?.addEventListener('click', () => {
			let reviewTab = document.querySelector('[review-tab]');
			if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
				reviewTab = document.querySelector('[review-button]');
			}
			reviewTab.getAttribute('aria-expanded') === 'false' && reviewTab.click();

			const reviewTabOffset = reviewTab.getBoundingClientRect().top;

			const reviewTabScrollTop = parseInt(window.getComputedStyle(reviewTab).getPropertyValue('scroll-margin-top'));
			const scrollTo = reviewTabOffset - reviewTabScrollTop;
			window.scrollBy({
				top: scrollTo,
				behavior: 'smooth',
			});
		});
	}, 1000);
});
class DiscountResult extends HTMLElement {
	connectedCallback() {
		this.observer = new MutationObserver((mutations) => {
			this.appliedDiscounts = JSON.parse(this.getAttribute('data-applied-discounts'));
			setTimeout(() => {
				this.querySelectorAll('.dcDiscountBox p').forEach((item) => {
					if (!this.appliedDiscounts.includes(item.innerText)) {
						fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
							const cartContent = await response2.json();
							document.documentElement.dispatchEvent(
								new CustomEvent('cart:updated', {
									bubbles: true,
									detail: {
										cart: cartContent,
									},
								}),
							);
							document.documentElement.dispatchEvent(
								new CustomEvent('cart:refresh', {
									bubbles: true,
									detail: {
										cart: cartContent,
									},
								}),
							);
						});
					}
				});
			}, 1000);
		});
		this.observer.observe(this, { childList: true, subtree: true });
	}
	disconnectedCallback() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}
}

customElements.define('discount-result', DiscountResult);